"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControls = void 0;
exports.addAccessControlsForInterface = addAccessControlsForInterface;
exports.mergeDeviceAccessControls = mergeDeviceAccessControls;
exports.checkUserId = checkUserId;
const _1 = __importStar(require("."));
const promise_debounce_1 = require("./promise-debounce");
function addAccessControlsForInterface(id, ...scryptedInterfaces) {
    const methods = scryptedInterfaces.map(scryptedInterface => _1.ScryptedInterfaceDescriptors[scryptedInterface]?.methods || []).flat();
    const properties = scryptedInterfaces.map(scryptedInterface => _1.ScryptedInterfaceDescriptors[scryptedInterface]?.properties || []).flat();
    const interfaces = scryptedInterfaces;
    return {
        id,
        methods,
        properties,
        interfaces,
    };
}
function mergeDeviceAccessControls(accessControls, dacls) {
    if (!accessControls || accessControls.devicesAccessControls === null)
        return accessControls;
    accessControls.devicesAccessControls || (accessControls.devicesAccessControls = []);
    accessControls.devicesAccessControls.push(...dacls);
    return accessControls;
}
class AccessControls {
    constructor(acl) {
        this.acl = acl;
    }
    deny(reason = 'User does not have permission') {
        throw new Error(reason);
    }
    shouldRejectDevice(id) {
        if (this.acl.devicesAccessControls === null)
            return false;
        if (!this.acl.devicesAccessControls)
            return true;
        const dacls = this.acl.devicesAccessControls.filter(dacl => dacl.id === id);
        return !dacls.length;
    }
    shouldRejectProperty(id, property) {
        if (this.acl.devicesAccessControls === null)
            return false;
        if (!this.acl.devicesAccessControls)
            return true;
        const dacls = this.acl.devicesAccessControls.filter(dacl => dacl.id === id);
        for (const dacl of dacls) {
            if (!dacl.properties || dacl.properties.includes(property))
                return false;
        }
        return true;
    }
    shouldRejectEvent(id, eventDetails) {
        if (this.acl.devicesAccessControls === null)
            return false;
        if (!this.acl.devicesAccessControls)
            return true;
        const dacls = this.acl.devicesAccessControls.filter(dacl => dacl.id === id);
        const { property } = eventDetails;
        if (property) {
            for (const dacl of dacls) {
                if (!dacl.properties || dacl.properties.includes(property))
                    return false;
            }
        }
        const { eventInterface } = eventDetails;
        for (const dacl of dacls) {
            if (!dacl.interfaces || dacl.interfaces.includes(eventInterface))
                return false;
        }
        return true;
    }
    shouldRejectInterface(id, scryptedInterface) {
        if (this.acl.devicesAccessControls === null)
            return false;
        if (!this.acl.devicesAccessControls)
            return true;
        const dacls = this.acl.devicesAccessControls.filter(dacl => dacl.id === id);
        for (const dacl of dacls) {
            if (!dacl.interfaces || dacl.interfaces.includes(scryptedInterface))
                return false;
        }
        return true;
    }
    shouldRejectMethod(id, method) {
        if (this.acl.devicesAccessControls === null)
            return false;
        if (!this.acl.devicesAccessControls)
            return true;
        const dacls = this.acl.devicesAccessControls.filter(dacl => dacl.id === id);
        for (const dacl of dacls) {
            if (!dacl.methods || dacl.methods.includes(method))
                return false;
        }
        return true;
    }
}
exports.AccessControls = AccessControls;
const accessControls = (0, promise_debounce_1.createCachingMapPromiseDebouncer)(60 * 1000);
async function checkUserId(id, userId) {
    const user = _1.default.systemManager.getDeviceById(userId);
    if (!user || !user.interfaces?.includes(_1.ScryptedInterface.ScryptedUser)) {
        // console.error('Error delivering notification, invalid user id:', userId);
        return;
    }
    if (!_1.default.systemManager.getDeviceById(id))
        return;
    try {
        const acl = await accessControls(userId, async () => {
            const acls = await user.getScryptedUserAccessControl();
            const acl = acls ? new AccessControls(acls) : undefined;
            return acl;
        });
        if (acl?.shouldRejectDevice(id)) {
            return;
        }
    }
    catch (e) {
        // console.error('Error delivering notification, ACL check failed.', e);
        return;
    }
    return user;
}
//# sourceMappingURL=acl.js.map